import { render } from "./Who.vue?vue&type=template&id=66b3b543&scoped=true"
import script from "./Who.vue?vue&type=script&lang=js"
export * from "./Who.vue?vue&type=script&lang=js"

import "./Who.vue?vue&type=style&index=0&id=66b3b543&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-66b3b543"

export default script